import { colors } from "@/constant/colors";
import MarkdownComponent from "../Markdown";
import ExpandExplanation from "./expandExplanation";
import MultipleChoice from "@/components/Choice/multiple-choice";
import VisualDiagram from "@/components/visual/VisualDiagram";
import { getQuestionPictureFallback, getQuestionVisual } from "@/lib/visual-diagram";

interface PracticeQuizProps {
  question: any;
  handleAnswer: (option: string, isCorrect: boolean) => void;
  currentAnswer: any;
  allFinished: boolean;
  disabled: boolean;
  isChatActive?: boolean;
}

const PracticeQuiz = ({
  question,
  handleAnswer,
  currentAnswer,
  allFinished,
  disabled,
  isChatActive = false,
}: PracticeQuizProps) => {
  const questionVisual = getQuestionVisual(question);
  const questionPictureFallback = getQuestionPictureFallback(question);

  const handleMultipleChoiceAnswer = (selectedOption: string, optionIndex: number, isCorrect: boolean) => {
    handleAnswer(selectedOption, isCorrect);
  };

  // 确定答案状态
  const getAnswerState = () => {
    if (currentAnswer.selectedOption === null) return "none";
    return currentAnswer.isCorrect ? "correct" : "incorrect";
  };

  return (
    <div className="w-full h-full text-[#573F35] items-center flex flex-col">
      <div className="max-w-[800px] px-4 text-xl text-[#573F35] text-center pb-4 emphasize-text">
        <MarkdownComponent content={question?.question} textStyle={{ textAlign: 'center', fontFamily: 'var(--font-emphasize)', color: colors.mainTextColor, fontSize: '20px', fontWeight: '700' }} />
      </div>
      {questionVisual && (
        <VisualDiagram
          visual={questionVisual}
          picture={questionPictureFallback}
          pictureAlt="Question diagram"
          context={typeof question?.question === 'string' ? question.question : ''}
        />
      )}
      <div className="flex flex-col gap-3 items-center mt-6 min-h-[15rem] w-full">
        <MultipleChoice
          id={question?.id || ''}
          options={question?.options || []}
          correctAnswer={question?.answer || ""}
          selectedAnswer={currentAnswer.selectedOption}
          answerState={getAnswerState()}
          disabled={disabled || allFinished || currentAnswer.selectedOption !== null}
          onAnswer={handleMultipleChoiceAnswer}
          enableShuffle={true}
          enableKeyboard={!isChatActive}
          responsive={false}
        />
      </div>
      {
        currentAnswer.selectedOption !== null && !currentAnswer.isCorrect && (
          <ExpandExplanation explanation={question?.explanation || ''} />
        )
      }
    </div>
  )
}

export default PracticeQuiz;
